<template lang="pug">
div
  .d-lg-none
    template(v-if="gameResult.length > 0")
      template(v-if="category === 'LIVECASINO'")    
        .d-flex.history-single(v-for="result in gameResult")
          .flex-grow-1
            .history-type(@click="getBetDetails(result.result_id, result.provider_code, result.remark)") {{result.result_id}}
            .history-type {{result.game_name}}
            .text-secondary.history-date {{ $moment(result.bet_time).format("YYYY-MM-DD HH:mm:ss") }}
          .ml-2.text-small
            .text-right.font-weight-normal {{$t(getText(result.winlose))}}: 
            .text-right {{$t('ui.commission')}}:
            .text-right {{$t('ui.turnover')}}:
          .ml-2.text-small
            .text-right.font-weight-normal(:class="getColor(result.winlose)") {{ $numeral(result.winlose).format("0,0.00") }}
            .text-right {{ $numeral(result.comm).format("0,0.00") }}
            .text-right {{result.turnover}}   
      template(v-else-if="category === 'SLOTS'")
        .d-flex.history-single(v-for="result in gameResult")
          .flex-grow-1.custom-max
            //- .history-type(v-if="result.provider_code=='UU'") {{result.result_id}}
            .history-type.custom-deco-mobile(v-if="result.provider_code=='KK'" @click="getBetDetails(result.result_id, result.provider_code, result.game_id)") {{result.result_id}}
            .history-type.custom-deco-mobile(v-else @click="getBetDetails(result.result_id, result.provider_code, result.remark)") {{result.result_id}}
            .history-type {{result.game_name}}
            .text-secondary.history-date {{ $moment(result.bet_time).format("YYYY-MM-DD HH:mm:ss") }}
          .ml-2.text-small
            .text-right.font-weight-normal {{ parseFloat(result.winlose) != 0 ? (parseFloat(result.winlose) < 0 ? $t("ui.lost") : $t("ui.win")) : $t("ui.draw") }}: 
            .text-right {{$t('ui.commission')}}:
            .text-right {{$t('ui.turnover')}}:
          .ml-2.text-small
            .text-right.font-weight-normal(:class="getColor(result.winlose)") {{ $numeral(result.winlose).format("0,0.00") }}
            .text-right {{ $numeral(result.comm).format("0,0.00") }}
            .text-right {{result.turnover}} 
      template(v-else-if="category === 'SPORTSBOOK'")
        .d-flex.history-single(v-for="result in gameResult")
          .flex-grow-1
            .history-type {{result.result_id}}
            .history-type {{result.game_name}}
            .history-type
              template(v-if="result.bet_type != 'PARLAY'")
                div {{$t('ui.'+ result.sports_category.toLowerCase())}} - {{ getBetTypeName(result.bet_type) }}
                div {{ getBetDetail(result) }}
                div(v-if="['HDP', 'HDPH', 'OU', 'OUH', '1X2HDP', '1X2HDPH'].includes(result.bet_type)") {{ result.bet_hand.split(" ")[1] }}
                div {{result.home_team_name}}
                div {{result.away_team_name}}
                div {{result.league_name}}
              template(v-else)
                div {{ getBetTypeName(result.bet_type) }}
                  span @ {{ result.odds_display_bet }}
            .text-secondary.history-date {{ $moment(result.bet_time).format("YYYY-MM-DD HH:mm:ss A") }}
          .ml-2.text-small
            .text-right {{$t('ui.odds')}}:
            .text-right {{$t('ui.stake')}}:
            .text-right.font-weight-normal {{$t(getText(result.winlose))}}: 
            .text-right {{$t('ui.commission')}}:
            .text-right {{$t('ui.turnover')}}:
          .ml-2.text-small
            .text-right {{ result.odds_display == 0 ? result.odds_display : formatOddsDisplay(result.odds_display, result.bet_type) }}
            .text-right {{ $numeral(result.bet_amount).format("0,0.00") }}
            .text-right.font-weight-normal(:class="getColor(result.winlose)") {{ $numeral(result.winlose).format("0,0.00") }}
            .text-right {{ $numeral(result.comm).format("0,0.00") }}
            .text-right {{result.turnover}}
      .row.pagenumber.my-4.mx-0
        paginate(
          v-if="!noHistory"
          :click-handler="changePage"
          :pageCount="pageCount"
          :page-range="4"
          :margin-pages="3"
          :prev-text="''"
          :next-text="''"
          :container-class="'p-0 m-center'"
          :page-class="'round'"
          :page-link-class="''"
          :prev-class="'round prev'"
          :next-class="'round next'"
          :prev-link-class="pageCount > 1 && currentPage != 1 ? '' : ''"
          :next-link-class="pageCount > 1 && currentPage != pageCount ? '' : ''")
    template(v-else)
      .text-center.text-white.my-2 {{ $t('ui.no_record') }}  
    .d-flex.justify-content-end.mt-3
      .text-white.pointer.btn-login.px-4(@click="backPrev") back
  .d-none.d-lg-block
    .package-table.mb-0
      template(v-if="gameResult.length > 0")
        template(v-if="category === 'LIVECASINO'")
          .row.table-row
            .col ID
            .col {{$t('ui.commission')}}
            .col {{$t('ui.game_name')}}
            .col {{$t('ui.winlose')}}
            .col {{$t('ui.turnover')}}
            .col {{$t('ui.bet_time')}}
          .row.table-row(v-for="result in gameResult")
            .col
              a.custom-deco.pointer(@click="getBetDetails(result.result_id, result.provider_code, result.game_id)") {{result.result_id}}
            .col {{ $numeral(result.comm).format("0,0.00") }}
            .col {{result.game_name}}
            .col(:class="getColor(result.winlose)") {{result.winlose}}
            .col {{result.turnover}}
            .col {{ $moment(result.bet_time).format("YYYY-MM-DD HH:mm:ss") }}
        template(v-else-if="category === 'SLOTS'")
          .row.table-row
            .col-5 ID
            .col {{$t('ui.game_name')}}
            .col-1 {{$t('ui.winlose')}}
            .col-1 {{$t('ui.turnover')}}
            .col-1 {{$t('ui.commission')}}
            .col {{$t('ui.bet_time')}}
          .row.table-row(v-for="result in gameResult")
            .col-5
              a.custom-deco(v-if="result.provider_code == 'KK'" href="javascript:void(0)" @click="getBetDetails(result.result_id, result.provider_code, result.game_id)") {{result.result_id}}
              //- a(v-else-if="result.provider_code == 'UU'") {{result.result_id}}
              a.custom-deco(v-else href="javascript:void(0)" @click="getBetDetails(result.result_id, result.provider_code, result.remark)") {{result.result_id}}
              
            .col {{result.game_name}}
            .col-1(:class="getColor(result.winlose)") {{result.winlose}}
            .col-1 {{result.turnover}}
            .col-1 {{ $numeral(result.comm).format("0,0.00") }}
            .col {{ $moment(result.bet_time).format("YYYY-MM-DD HH:mm:ss") }}
        template(v-else-if="category === 'SPORTSBOOK'")
          .row.table-row
            .col {{$t('ui.bet_time')}}
            .col-3 {{$t('ui.event')}}
            .col-1 {{$t('ui.odds')}}
            .col-1 {{$t('ui.stake')}}
            .col {{$t('ui.winlose')}}
            .col-1 {{$t('ui.status')}}
            .col {{$t('ui.commission')}}
            .col {{$t('ui.turnover')}}
          .row.table-row(v-for="result in gameResult")
            .col.text-left 
              div {{result.result_id}} 
              .text-secondary {{ $moment(result.bet_time).format("YYYY-MM-DD HH:mm:ss A") }}
            .col-3.text-left
              template(v-if="result.bet_type != 'PARLAY'")
                div {{$t('ui.'+ result.sports_category.toLowerCase())}} - {{ getBetTypeName(result.bet_type) }}
                div {{ getBetDetail(result) }}
                div(v-if="['HDP', 'HDPH', 'OU', 'OUH', '1X2HDP', '1X2HDPH'].includes(result.bet_type)") {{ result.bet_hand.split(" ")[1] }}
                div {{result.home_team_name}}
                div {{result.away_team_name}}
                div {{result.league_name}}
              template(v-else)
                div {{ getBetTypeName(result.bet_type) }}
                  span @ {{ result.odds_display_bet }}
            .col-1
              div(:class="{ 'text-danger': parseFloat(result.odds_display) < 0 }") {{ result.odds_display == 0 ? result.odds_display : formatOddsDisplay(result.odds_display, result.bet_type) }}
            .col-1 {{ $numeral(result.bet_amount).format("0,0.00") }}
            .col 
              div 
                span(:class="{ 'text-danger': parseFloat(result.winlose) < 0 }") {{ $numeral(result.winlose).format("0,0.00") }}
            .col-1 {{ parseFloat(result.winlose) != 0 ? (parseFloat(result.winlose) < 0 ? $t("ui.lost") : $t("ui.win")) : $t("ui.draw") }}
            .col {{ $numeral(result.comm).format("0,0.00") }}
            .col {{result.turnover}} 
        .row.pagenumber.my-4
          paginate(
            v-if="!noHistory"
            :click-handler="changePage"
            :pageCount="pageCount"
            :page-range="4"
            :margin-pages="3"
            :prev-text="''"
            :next-text="''"
            :container-class="'p-0 m-center'"
            :page-class="'round'"
            :page-link-class="''"
            :prev-class="'round prev'"
            :next-class="'round next'"
            :prev-link-class="pageCount > 1 && currentPage != 1 ? '' : ''"
            :next-link-class="pageCount > 1 && currentPage != pageCount ? '' : ''")
      template(v-else)
        .text-center.my-2 {{ $t('ui.no_record') }}
    .d-flex.justify-content-end.mt-3
      .text-white.pointer.btn-login.px-4(@click="backPrev") back
  //- .statement-mobile
  //-   template(v-if="this.category === 'SPORTSBOOK'")
  //-     template(v-if="gameResult.length > 0")
  //-       .statement-single(v-for="data in gameResult")  
  //-         .statement-single-content  
  //-           .statement-date {{ $moment(data.bet_time).format("YYYY-MM-DD HH:mm:ss A") }}
  //-           .statement-detail
  //-             .statement-detail-left {{ $t("ui.ref_no") }}: 
  //-             .statement-detail-right {{ data.result_id }}
  //-           .statement-detail
  //-             template(v-if="data.bet_type != 'PARLAY'")
  //-               .statement-detail-left
  //-                 div {{$t('ui.'+ data.sports_category.toLowerCase())}} - {{ getBetTypeName(data.bet_type) }}
  //-                 div {{ getBetDetail(data) }}
  //-                 div(v-if="['HDP', 'HDPH', 'OU', 'OUH', '1X2HDP', '1X2HDPH'].includes(data.bet_type)") {{ data.bet_hand.split(" ")[1] }}
  //-                 div {{data.home_team_name}}
  //-                 div {{data.away_team_name}}
  //-                 div {{data.league_name}}
  //-               .statement-detail-right   
  //-             template(v-else)
  //-               div {{ getBetTypeName(data.bet_type) }}
  //-                 span @ {{ data.odds_display_bet }}
  //-           .statement-detail
  //-             .statement-detail-left {{$t('ui.odds')}}
  //-             .statement-detail-right(:class="{ 'text-danger': parseFloat(data.odds_display) < 0 }") {{ data.odds_display == 0 ? data.odds_display : formatOddsDisplay(data.odds_display, data.bet_type) }}
  //-           .statement-detail
  //-             .statement-detail-left {{$t('ui.stake')}}
  //-             .statement-detail-right {{ $numeral(data.bet_amount).format("0,0.00") }}
  //-           .statement-detail
  //-             .statement-detail-left {{ $t('ui.winlose') }}
  //-             .statement-detail-right {{data.winlose}}
  //-           .statement-detail
  //-             .statement-detail-left {{ $t('ui.status') }}
  //-             .statement-detail-right {{ parseFloat(data.winlose) != 0 ? (parseFloat(data.winlose) < 0 ? $t("ui.lost") : $t("ui.win")) : $t("ui.draw") }}
        
  //-     template(v-else)
  //-       .text-center.my-2 {{ $t('ui.no_record') }}
  //-   template(v-else)
  //-     template(v-if="gameResult.length > 0")
  //-       .statement-single(v-for="data in gameResult")  
  //-         .statement-single-content  
  //-           .statement-date {{ $moment(data.bet_time).format("YYYY-MM-DD HH:mm:ss") }}
  //-           .statement-detail
  //-             .statement-detail-left ID
  //-             .statement-detail-right
  //-               a(href="javascript:void(0)" @click="getBetDetails(data.result_id, data.provider_code)") {{data.result_id}}
  //-           .statement-detail
  //-             .statement-detail-left {{ $t('ui.game_name') }}
  //-             .statement-detail-right {{data.game_name}}
  //-           .statement-detail
  //-             .statement-detail-left {{ $t('ui.winlose') }}
  //-             .statement-detail-right {{data.winlose}}
  //-     template(v-else)
  //-       .text-center.my-2 {{ $t('ui.no_record') }}
  //- .statement-desktop
  //-   .table-statement
  //-     template(v-if="this.category === 'SPORTSBOOK'")
  //-       .row.table-statement-row
  //-         .col.table-statement-col.index-col No.
  //-         .col.table-statement-col.custom-col-1 {{$t('ui.trans_time')}}
  //-         .col.table-statement-col.custom-col-2 {{$t('ui.event')}}
  //-         .col.table-statement-col {{$t('ui.odds')}}
  //-         .col.table-statement-col {{$t('ui.stake')}}
  //-         .col.table-statement-col.custom-col-3 {{$t('ui.winlose')}}
  //-         .col.table-statement-col {{$t('ui.status')}}
  //-         //- th No.
  //-         //- th {{$t('ui.trans_time')}}
  //-         //- th {{$t('ui.event')}}
  //-         //- th {{$t('ui.odds')}}
  //-         //- th {{$t('ui.stake')}}
  //-         //- th {{$t('ui.winlose')}}
  //-         //- th {{$t('ui.status')}}
  //-       template(v-if="gameResult.length > 0")
  //-         .row.table-statement-row(v-for="(data, index) in gameResult")
  //-           .col.table-statement-col.index-col {{index+1}}
  //-           .col.table-statement-col.custom-col-1
  //-             div {{ $t("ui.ref_no") }}: {{ data.result_id }}
  //-             div {{ $moment(data.bet_time).format("YYYY-MM-DD HH:mm:ss A") }}
  //-           .col.table-statement-col.custom-col-2
  //-             template(v-if="data.bet_type != 'PARLAY'")
  //-               div {{$t('ui.'+ data.sports_category.toLowerCase())}} - {{ getBetTypeName(data.bet_type) }}
  //-               div {{ getBetDetail(data) }}
  //-               div(v-if="['HDP', 'HDPH', 'OU', 'OUH', '1X2HDP', '1X2HDPH'].includes(data.bet_type)") {{ data.bet_hand.split(" ")[1] }}
  //-               div {{data.home_team_name}}
  //-               div {{data.away_team_name}}
  //-               div {{data.league_name}}
  //-             template(v-else)
  //-               div {{ getBetTypeName(data.bet_type) }}
  //-                 span @ {{ data.odds_display_bet }}
  //-           .col.table-statement-col
  //-             div(:class="{ 'text-danger': parseFloat(data.odds_display) < 0 }") {{ data.odds_display == 0 ? data.odds_display : formatOddsDisplay(data.odds_display, data.bet_type) }}
  //-           .col.table-statement-col {{ $numeral(data.bet_amount).format("0,0.00") }}
  //-           .col.table-statement-col.custom-col-3
  //-             div 
  //-               span(:class="{ 'text-danger': parseFloat(data.winlose) < 0 }") {{ $numeral(data.winlose).format("0,0.00") }}
  //-           .col.table-statement-col {{ parseFloat(data.winlose) != 0 ? (parseFloat(data.winlose) < 0 ? $t("ui.lost") : $t("ui.win")) : $t("ui.draw") }}
  //-         .row.pagenumber.my-4
  //-           paginate(
  //-             v-if="!noHistory"
  //-             :click-handler="changePage"
  //-             :pageCount="pageCount"
  //-             :page-range="4"
  //-             :margin-pages="3"
  //-             :prev-text="''"
  //-             :next-text="''"
  //-             :container-class="'p-0 m-0'"
  //-             :page-class="'round'"
  //-             :page-link-class="''"
  //-             :prev-class="'round prev'"
  //-             :next-class="'round next'"
  //-             :prev-link-class="pageCount > 1 && currentPage != 1 ? '' : ''"
  //-             :next-link-class="pageCount > 1 && currentPage != pageCount ? '' : ''")
  //-       template(v-else)
  //-         .text-center.my-2 {{ $t('ui.no_record') }}
  //-     template(v-else)
  //-       .row.table-statement-row
  //-         .col.table-statement-col ID
  //-         .col.table-statement-col {{$t('ui.game_name')}}
  //-         .col.table-statement-col {{$t('ui.winlose')}}
  //-         .col.table-statement-col {{$t('ui.date')}}
  //-       template(v-if="gameResult.length > 0")
  //-         .row.table-statement-row(v-for="data in gameResult")
  //-           .col.table-statement-col.no-uppercase
  //-             a(href="javascript:void(0)" @click="getBetDetails(data.result_id, data.provider_code)") {{data.result_id}}
  //-           .col.table-statement-col {{data.game_name}}
  //-           .col.table-statement-col {{data.winlose}}
  //-           .col.table-statement-col {{ $moment(data.bet_time).format("YYYY-MM-DD HH:mm:ss") }}
  //-         .row.pagenumber.my-4
  //-           paginate(
  //-             v-if="!noHistory"
  //-             :click-handler="changePage"
  //-             :pageCount="pageCount"
  //-             :page-range="4"
  //-             :margin-pages="3"
  //-             :prev-text="''"
  //-             :next-text="''"
  //-             :container-class="'p-0 m-0'"
  //-             :page-class="'round'"
  //-             :page-link-class="''"
  //-             :prev-class="'round prev'"
  //-             :next-class="'round next'"
  //-             :prev-link-class="pageCount > 1 && currentPage != 1 ? '' : ''"
  //-             :next-link-class="pageCount > 1 && currentPage != pageCount ? '' : ''")
  //-       template(v-else)
  //-         .text-center.my-2 {{ $t('ui.no_record') }}
</template>
<script>
import config from '@/config'
import Paginate from "vuejs-paginate";
export default {
  components: {
    Paginate,
  },
  props:{   
    category: {
      type: String,
    },
  },
  data(){
    return{
      // noHistory: true
      working_date: "",
      currentPage: 1,
      feedback: {
        status: "",
        success: ""
      },
      pageSize: 10,
      path: "",
      resultData: [],
    }
  },
  computed:{
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
    gameResult(){
      if(this.category === 'LIVECASINO'){
        return this.$store.getters.livecasinoResult.data.GAMERESULTLC;
      }else if(this.category === 'SLOTS'){
        return this.$store.getters.slotResult.data.GAMERESULTSLOTS;
      }else if(this.category === 'SPORTSBOOK'){
        return this.$store.getters.sbResult.data.GAMERESULT;
      }else{
        return ""
      }
    },
    workingDate() {
      if(this.category === 'LIVECASINO'){
        return this.$store.getters.livecasinoResult.working_date;
      }else if(this.category === 'SLOTS'){
        return this.$store.getters.slotResult.working_date;
      }else if(this.category === 'REBATE'){
        return this.$store.getters.rebateResult.working_date;
      }else if(this.category === 'SPORTSBOOK'){
        return this.$store.getters.sbResult.working_date;
      }else{
        return ""
      }
    },
    noHistory(){
      if(this.gameResult.length > 0){
        return false
      }else{
        return true
      }
    },
    pageCount() {
      if (!this.noHistory) {
        var page = this.gameResult[0].totalrows / 10;
        if (page % 1 != 0) {
          page = page + 1;
        }
        return Math.floor(page);
      } else {
        return 0;
      }
    }
  },
  beforeDestroy(){
    this.reset()
  },
  mounted(){
    window.scroll(0,0)
    // if(this.gameResult.length > 0){
    //   this.noHistory = false
    // }

  },
  methods:{
    backPrev(){
      this.$emit("backPrev")
    },
    getText(value) {
      if (value > 0) {
        return "ui.win";
      } else if (value < 0) {
        return "ui.lose";
      } else {
        return "ui.tie";
      }
    },
    getBetTypeName(e) {
      return this.$t("m.BT_" + e);
    },
    formatOddsDisplay(odds, bet_type) {
      if (bet_type == "cs") return calc.fmcs(odds);
      else return this.$helpers.fmt(odds);
    },
    getBetDetail(bet) {
      return this.$helpers.betDisplay(bet, this);
    },
    changePage(e) {
      this.currentPage = e;
      this.$emit("getDifferentPage", {
        workingDate: this.workingDate,
        pageSize: this.pageSize,
        newPage: e,
        category: this.category
      })
    },
    reset(){
      // this.noHistory = true
    },
    getBetDetails(id, provider, actionId){
      switch(provider){
        case "NK":
          this.path = "user/getNekoResult"
          break;
        case "LIVE22":
          this.path = "user/getLive22Result"
          break;
        case "KK":
          this.path = "user/getKingkongResult";
          break;
        case "HBNR":
          this.path = "user/getHbResult"
          break;
        case "PEG":
          this.path = "user/getPegResult"
          break;
        case "UU":
          this.path = "user/getUuResult"
          break;
        default:
          this.path = ""
      }
      var vm = this
      if(provider === "NK"){
        const routeData = this.$router.resolve({name: '/betdetail', query: { action : id + "&" + actionId} })
        window.open(
          routeData.href,
          "info",
          "toolbar=no,scrollbars=no,resizable=no,top=0,left=0,width=800,height=640"
        );
      }else if(provider === "KK"){
        let player_id = this.accountID
        let ticket_id = id
        let lang_code = this.getLanguage
        let game_code = actionId
        this.$store
          .dispatch(this.path, { player_id, ticket_id, lang_code, game_code })
          .then(response => {
            if (response.success == true) {
              setTimeout(() => {
                window.open(
                  response.data,
                  "info",
                  "toolbar=no,scrollbars=no,resizable=no,top=0,left=0,width=480,height=640"
                );
              }) 
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }else if(provider === "LG"){
        var result = `https://resultlg.uatmmk5.com/result?player_id=${this.accountID}&auth_token=${this.sessionToken}&result_id=${id}`
        setTimeout(() => {
          window.open(
            result,
            "info",
            "toolbar=no,scrollbars=no,resizable=no,top=0,left=0,width=480,height=640"
          );
        }) 
      }else{
        let player_id = this.accountID
        let ticket_id = id
        let lang_code = this.getLanguage
        this.$store
          .dispatch(this.path, { player_id, ticket_id, lang_code })
          .then(response => {
            if (response.success == true) {
              setTimeout(() => {
                window.open(
                  response.data,
                  "info",
                  "toolbar=no,scrollbars=no,resizable=no,top=0,left=0,width=480,height=640"
                );
              }) 
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    },
    getColor(value) {
      if (value > 0) {
        return "text-success";
      } else if (value < 0) {
        return "text-color01";
        // return "text-danger";
      } else {
        return "";
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.text-secondary{
  font-size: 0.75rem !important
}
.m-center{
  margin: 0 auto;
}
.custom-deco{
  text-decoration: underline;
  color: #007bff;
}
.custom-deco-mobile{
  text-decoration: underline;
  color: #007bff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  
}
.custom-max{
  max-width: 65%;
}
</style>